export const COLUMN_SAMPLE_SIZE = 200;

export const REPORTS_WITH_PROVIDER_INFO = [
  'payment_by_provider',
  'charges_by_provider',
  'financial_reporting',
  'product_sale',
  'accounts_receivable',
  'provider_compensation'
];
